import { useMemo } from 'react';
import { useClinicalTrialContextSlice } from '@restore/clinicalTrialContext/clinicalTrialContext.slice';
import {
  queriesColumns,
  type Handlers,
} from 'src/components/Queries/Queries.table.config';

export const useQueriesColumns = (handlers?: Handlers) => {
  const contextData = useClinicalTrialContextSlice(state => state.data);

  const siteIdToCode = useMemo(() => {
    const acc: Record<string, string> = {};
    const sites = contextData?.configuration?.sites ?? [];
    for (const s of sites) {
      if (s?.id) acc[s.id] = s.code;
    }
    return acc;
  }, [contextData?.configuration?.sites]);

  return useMemo(
    () => queriesColumns(handlers, siteIdToCode),
    [siteIdToCode, handlers]
  );
};
